import React from 'react';

export default class ExchangePopoverItem extends React.Component {
  constructor(props) {
    super(props);

    this._onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(e) {
    ShiftStore.trigger('shift:deeplink', this.props.shift_id, this.props.selectDate);
    if (this.props.clickHandler) {
      this.props.clickHandler(e);
    }
    e.preventDefault();
  }

  render() {
    return (
      <li onClick={this._onClickHandler}>
        <strong>
          {this.props.title}
          {' '}
          <span className="pendingState">
            {!Utils.isNotDefined(this.props.state) ? ` - ${this.props.state}` : ''}
          </span>
        </strong>
        <br />
        {this.props.shiftDate}
        {' '}
        {this.props.startTime}
        {' '}
-
        {' '}
        {this.props.endTime}
        <br />
        {this.props.viewOffers}
      </li>
    );
  }
}
